/*
 * General custom scripts
 */

/**
 * Header
 */
import { menu } from './front/menu';
// Initialize components
document.addEventListener( 'DOMContentLoaded', () => {

	menu();

} );
